import { Button, CardContent, Tooltip, FormGroup, Stack, FormControlLabel, Checkbox, Grid2, Radio, RadioGroup, FormControl, FormLabel } from "@mui/material"
import { useEffect, useState } from "react"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogTitle from "@mui/material/DialogTitle"
import PaperComponent from "./paper-component"
import * as FileSaver from "file-saver"
import * as XLSX from "xlsx"
import { FileDownload } from "@mui/icons-material"
import { entityFromExportName, trackEvent } from "utils/analytics"

const CustomExportButton = ({ exportOptions }) => {
  const { hiddenColumns, columns, data, fileName } = exportOptions
  const [open, setOpen] = useState(false)
  const [state, setState] = useState({})
  const [format, setFormat] = useState("xlsx")

  useEffect(() => {
    if (columns) {
      const hiddenColumnsKeys = Object.keys(hiddenColumns).filter(x => !hiddenColumns[x])
      const initialState = {}
      columns.forEach(x => (initialState[x.field] = !hiddenColumnsKeys.includes(x.field)))

      setState(initialState)
    }
  }, [exportOptions])

  const handleChange = event => {
    setState({
      ...state,
      [event.target.name]: event.target.checked,
    })
  }

  const handleConfirm = async () => {
    const dataSource = []
    const exportingColumns = columns?.filter(x => state[x.field])
    data?.forEach(item => {
      const row = {}
      exportingColumns.forEach(column => {
        row[column.headerName] = item[column.field]
      })
      dataSource.push(row)
    })

    const ws = XLSX.utils.json_to_sheet(dataSource)

    if (format === "csv") {
      const csv = XLSX.utils.sheet_to_csv(ws)
      // Prepend BOM so Excel opens UTF-8 CSVs correctly.
      const blob = new Blob(["﻿", csv], { type: "text/csv;charset=utf-8" })
      FileSaver.saveAs(blob, fileName + ".csv")
    } else {
      const wb = {
        Sheets: { data: ws },
        SheetNames: ["data"],
      }
      const excelBuffer = XLSX.write(wb, {
        bookType: "xlsx",
        type: "array",
        cellStyles: "true",
        cellNF: "true",
      })
      const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8"
      const blob = new Blob([excelBuffer], { type: fileType })
      FileSaver.saveAs(blob, fileName + ".xlsx")
    }
    trackEvent("export", { entity: entityFromExportName(fileName), format, columns_count: exportingColumns.length })

    setOpen(false)
  }

  return (
    <>
      <Tooltip placement="top" title="Export data to Excel">
        <Button color="primary" variant="text" onClick={() => setOpen(true)} startIcon={<FileDownload />}>
          Export
        </Button>
      </Tooltip>
      <Dialog open={open} onClose={() => setOpen(false)} PaperComponent={PaperComponent} aria-labelledby="draggable-dialog-title">
        <DialogTitle style={{ cursor: "move", display: "flex", alignItems: "center", justifyContent: "space-between" }} id="draggable-dialog-title">
          <span>Select columns to export</span>
          <FormControlLabel
            control={
              <Checkbox
                checked={columns?.every(x => state[x.field])}
                indeterminate={columns?.some(x => state[x.field]) && !columns.every(x => state[x.field])}
                onChange={e => {
                  const checked = e.target.checked
                  const newState = {}
                  columns.forEach(x => {
                    newState[x.field] = checked
                  })
                  setState(newState)
                }}
              />
            }
            label="Select All"
            style={{ marginLeft: 16 }}
          />
        </DialogTitle>
        <DialogContent dividers>
          <CardContent>
            <FormControl sx={{ mb: 2 }}>
              <FormLabel>Format</FormLabel>
              <RadioGroup row value={format} onChange={e => setFormat(e.target.value)}>
                <FormControlLabel value="xlsx" control={<Radio />} label="Excel (.xlsx)" />
                <FormControlLabel value="csv" control={<Radio />} label="CSV (.csv)" />
              </RadioGroup>
            </FormControl>
            <FormGroup>
              <Grid2 container spacing={2}>
                {columns?.map(x => {
                  return (
                    <Grid2 key={x.field} size={4}>
                      <FormControlLabel control={<Checkbox checked={state[x.field]} onChange={handleChange} name={x.field} />} label={x.headerName} />
                    </Grid2>
                  )
                })}
              </Grid2>
            </FormGroup>
          </CardContent>
        </DialogContent>
        <DialogActions>
          <Button id="btnOKConfirm" onClick={handleConfirm} variant="contained">
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default CustomExportButton
